import { render, staticRenderFns } from "./LearnerAnnualMarksheetPrePrimIcseView.vue?vue&type=template&id=4f3f88c2&scoped=true&style=background-color%3A%20white%3B&"
import script from "./LearnerAnnualMarksheetPrePrimIcseView.vue?vue&type=script&lang=js&"
export * from "./LearnerAnnualMarksheetPrePrimIcseView.vue?vue&type=script&lang=js&"
import style0 from "./LearnerAnnualMarksheetPrePrimIcseView.vue?vue&type=style&index=0&id=4f3f88c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3f88c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCol,VRow,VSimpleTable,VSnackbar})
